"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slotShouldForwardProp = exports.shouldForwardProp = exports.rootShouldForwardProp = void 0;
const shouldForwardProp = prop => prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
exports.shouldForwardProp = shouldForwardProp;
const rootShouldForwardProp = prop => shouldForwardProp(prop) && prop !== 'classes';
exports.rootShouldForwardProp = rootShouldForwardProp;
const slotShouldForwardProp = exports.slotShouldForwardProp = shouldForwardProp;
//# sourceMappingURL=shouldForwardProps.js.map